<template>
  <div id="chatInterface">
    <deep-chat
      ref="chatElement"
      :demo="false"
      :textInput="textInput"
      :chatStyle="chatStyleClass"
      :introMessage="introMessage"
      :messageStyles="messageStyles"
      :submitButtonStyles="submitButtonStyles"
      :htmlClassUtilities="htmlClassUtilities"
      :connect="connect"
    ></deep-chat>
  </div>
</template>

<script>
import "deep-chat";
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";

export default {
  name: "ChatPage",
  components: {},
  methods: {
    updateFlowchart(event) {
      const button = event.target.closest(".feedback-icon-flow");
      const feedbackElement = button.closest(".feedback");
      const updated_nodes =
        feedbackElement.querySelector(".hidden-flow-nodes").textContent;
      const updated_edges =
        feedbackElement.querySelector(".hidden-flow-edges").textContent;

      console.log("manual update");

      // console.log(updated_flowchart);
      this.$emit(
        "updateFlowChart",
        JSON.parse(updated_nodes),
        JSON.parse(updated_edges)
      );
    },
  },
  setup() {
    return {};
  },
  props: {
    width: Number,
    flowNodes: Object,
    flowEdges: Object,
    chatConfig: {
      type: Object,
      required: true,
      default: () => ({
        action: "",
        detail: "",
        user_type: "",
        existing_tools: "",
      }),
    },
  },
  mounted() {
    if (this.$refs.chatElement) {
      // Add the request interceptor to transform the request format
      this.$refs.chatElement.requestInterceptor = (requestDetails) => {
        console.log("Original request:", requestDetails);
        // Extract messages from the deep-chat format
        const messages = requestDetails.body.messages || [];
        console.log(messages);
        // Transform to Moonarch API format
        // requestDetails.body = {
        //   messages: messages.map((msg) => ({
        //     role: msg.role || (msg.isUser ? "user" : "assistant"),
        //     content: msg.text,
        //   })),
        // };
        requestDetails.body = {
          // data: {
          new_message: messages[0].text,
          previous_ai_messages: [this.prev_ai_msg],
          previous_user_messages: [this.prev_user_msg],
          previous_edges: this.flowEdges,
          previous_nodes: this.flowNodes,

          action: this.chatConfig.action,
          detail: this.chatConfig.detail,
          user_type: this.chatConfig.user_type,
          existing_tools: this.chatConfig.existing_tools,
          // },
        };
        this.prev_user_msg = messages[0].text;
        console.log("Transformed request:", requestDetails);
        return requestDetails;
      };

      // Add a response interceptor to extract the response correctly
      this.$refs.chatElement.responseInterceptor = (response) => {
        console.log("Original response:", response);

        // Check if we have a valid response
        if (
          response &&
          response.data &&
          response.data.flowchart &&
          response.data.questions
        ) {
          const assistantMessage = response.data.questions.questions_string;

          console.log(assistantMessage);
          this.prev_ai_msg = assistantMessage;
          // this.flowjson =
          // Transform to deep-chat's expected format
          let newFlowNodes = response.data.flowchart.flowNodes;
          let newFlowEdges = response.data.flowchart.flowEdges;

          this.$emit("updateFlowChart", newFlowNodes, newFlowEdges);

          let additional_message = "Flow chart was updated";

          return {
            text: assistantMessage,
            role: assistantMessage.role,
            flowNodes: newFlowNodes,
            html: `<div class="feedback" style="justify-content: space-between">
                  <div class="feedback-text">${additional_message}</div>
                  <div class="hidden-flow-nodes" style="display: none">${JSON.stringify(
                    newFlowNodes
                  )}</div>
                  <div class="hidden-flow-edges" style="display: none">${JSON.stringify(
                    newFlowEdges
                  )}</div>
                  <div class="feedback-icon feedback-icon-flow" style="height: 35px !important; width: 35px !important; display: flex; justify-content: center; align-items: center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="6 3 20 12 6 21 6 3"/></svg>
                  </div>
                </div>`,
          };
        }

        // Handle error case
        return { text: "Sorry, I couldn't process that request." };
      };
    }
  },
  data() {
    // let calc_vw = window.innerWidth;
    let calc_vh = window.innerHeight;
    // console.log(calc_vw);
    console.log(this.width);

    console.log(this.chatConfig);

    return {
      prev_ai_msg: "",
      prev_user_msg: "",
      chatStyleClass: {
        "backgroundColor": "#f9f4ff",
        // "borderRadius": "8px",
        "border": "none",
        // "width": this.width + "px",
        "width": "440px", //FINDME
        "maxWidth": "none",
        "height": calc_vh - 51 + "px",
      },
      introMessage: {
        "text": "Hi I am your workflow builder, describe me your workflow!",
      },
      textInput: {
        "styles": {
          "text": { "color": "#02001A" },
          "container": {
            "maxHeight": "200px",
            "minHeight": "70px",
            "borderRadius": "10px",
            "backgroundColor": "#f5f9ff",
            "border": "1px solid #cccccc",
            "padding": "10px",
            // "width": this.width - 50 + "px",
            "width": "90%",
          },
          "hover": { "border": "1px solid #721cff" },
          "focus": {
            "border": "1px solid #721cff",
            "boxShadow": "0 0 0 3px #ccadff",
          },
        },
        "placeholder": {
          "text": "Describe your workflow",
          "style": { "color": "#808080" },
        },
      },
      messageStyles: {
        "default": {
          "shared": {
            "bubble": {
              // "width": this.width + "px",
              "width": "100%",
              "maxWidth": "none",
              "backgroundColor": "unset",
              "marginTop": "10px",
              "marginBottom": "10px",
            },
          },
          "user": {
            "bubble": {
              "marginLeft": "0px",
              "color": "black",
            },
          },
          "ai": {
            "outerContainer": {
              // "backgroundColor": "rgba(247,247,248)",
              "backgroundColor": "white",
              "border": "1px solid rgba(0,0,0,.1)",
              "margin": "10px",
              "borderRadius": "7px",
            },
          },
        },
      },
      connect: {
        // https://cors-anywhere.herokuapp.com/
        "url":
          "https://moonarchio--moonarch-backend-tools.modal.run/orchestrator",
        "method": "POST",
        "headers": {
          // "Accept": "application/json",
          // "Content-Type": "application/json",
          "Authorization":
            "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicG9ydGFsIiwic3Vic2NyaXB0aW9uX3RpZXIiOiJhZG1pbiIsImV4cGlyeV9kYXRlIjoiMjAyNi0wNC0xMFQxNjoyODo0MS44ODc3NDYrMDA6MDAiLCJleHAiOjE3NzU4Mzg1MjF9.A5z62qNGvjQQb-0-rblMyFZ7VBbW9LDa8vqV-NHyvKI",
        },
        // "additionalBodyProps": {
        // "model": "accounts/fireworks/models/deepseek-r1", //accounts/fireworks/models/deepseek-coder-r1
        "additionalBodyProps": {
          // "data": [
          // {
          "new_message": "hello there",
          "previous_user_messages": ["asda"],
          "previous_ai_messages": ["asda", "asdfasd"],
          "previous_nodes": [{ "asda": 1 }],
          "previous_edges": [{ "asda": 1 }],

          "action": this.chatConfig.action,
          "detail": this.chatConfig.detail,
          "user_type": this.chatConfig.user_type,
          "existing_tools": this.chatConfig.existing_tools,
          // },
          // ],
        },
      },
      submitButtonStyles: {
        "submit": {
          "container": {
            "default": {
              "backgroundColor": "#721cff",
              "max-height": "35px",
              "max-width": "35px",
              "min-height": "35px",
              "min-width": "35px",
              "display": "flex",
              "align-items": "center",
              "justify-content": "center",
              "border-radius": "7px",
            },
            "hover": { "backgroundColor": "#580fcd" },
            "click": { "backgroundColor": "#580fcd" },
          },
          "svg": {
            "content":
              '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-icon lucide-arrow-up"><path d="m5 12 7-7 7 7"/><path d="M12 19V5"/></svg>',
          },
        },
        "loading": {
          "container": {
            "default": {
              "backgroundColor": "#ccadff",
              "max-height": "35px",
              "max-width": "35px",
              "min-height": "35px",
              "min-width": "35px",
              "display": "flex",
              "align-items": "center",
              "justify-content": "center",
              "border-radius": "7px",
            },
          },
          "svg": {
            "content":
              '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-pause-icon lucide-circle-pause"><circle cx="12" cy="12" r="10"/><line x1="10" x2="10" y1="15" y2="9"/><line x1="14" x2="14" y1="15" y2="9"/></svg>',
          },
        },
        "alwaysEnabled": false,
      },
      htmlClassUtilities: {
        feedback: {
          styles: {
            default: {
              display: "flex",
            },
          },
        },
        "feedback-text": {
          styles: {
            default: {
              width: "calc(100% - 42px)",
              paddingTop: "2px",
            },
          },
        },
        "feedback-icon": {
          styles: {
            default: {
              width: "20px",
              height: "20px",
              cursor: "pointer",
              borderRadius: "5px",
            },
            hover: {
              backgroundColor: "#d1d1d1",
            },
          },
        },
        "feedback-icon-flow": {
          events: {
            click: (e) => this.updateFlowchart(e),
            // click: (e) => console.log("clicked on" + e),
          },
        },
      },
    };
  },
};
</script>

<style>
#chatInterface {
  /* width: fit-content; */
  width: 440px;
  height: 100%;
  /* height: calc(100vh); */
  /* background: #580fcd; */
  /* padding: 10px; */
}
/* .feedback {
  background: red;
} */
</style>
